//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pathToRegexp from 'path-to-regexp';
import { roterPre } from '@/settings';
export default {
  name: 'GuidancePop',
  props: ['url', 'image', 'info'],
  data: function data() {
    return {};
  }
};